"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartAddPaybackAccount = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function trackCartAddPaybackAccount() {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.Cart,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: enums_1.EventLabelCartButtonClickEnum.Payback,
        eventData: {
            eventName: enums_1.GA4EventName.AddPaybackAccount,
            feature_category: enums_1.GA4FeatureCategory.Cart,
        },
    });
}
exports.trackCartAddPaybackAccount = trackCartAddPaybackAccount;
//# sourceMappingURL=trackCartAddPaybackAccount.js.map